import { StandardEvents } from '@shopify/events';

const dialog = document.getElementById('purebau-cart-popup');
if (dialog) {
  const close = () => { if (dialog.open) dialog.close(); };
  dialog.querySelector('.purebau-popup__close').addEventListener('click', close);
  dialog.querySelector('.purebau-popup__continue').addEventListener('click', close);
  dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
  let serial = 0;
  const root = window.Shopify?.routes?.root || '/';
  const tiers = [{ n: 2, pct: 4 }, { n: 4, pct: 6 }, { n: 6, pct: 8 }, { n: 10, pct: 10 }];
  document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
    if (event.action !== 'add' || event.context !== 'product' || !event.promise) return;
    const sourceModal = event.target instanceof Element ? event.target.closest('dialog:modal') : null;
    const request = ++serial;
    try {
      const { detail } = await event.promise;
      if (detail?.didError || request !== serial) return;
      if (sourceModal?.open) await new Promise(resolve => sourceModal.addEventListener('close', resolve, { once: true }));
      const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin' });
      if (!cartResponse.ok || request !== serial) return;
      const cart = await cartResponse.json();
      const quantity = Number(cart.item_count) || 0;
      const added = cart.items.find(item => String(item.product_id) === String(detail?.productId)) || cart.items[0];
      const img = dialog.querySelector('.purebau-popup__added-image');
      const image = added?.featured_image?.url || added?.image;
      img.hidden = !image;
      if (image) img.src = image;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency || 'USD' });
      dialog.querySelector('.purebau-popup__summary').textContent = `Your cart: ${quantity} ${quantity === 1 ? 'item' : 'items'} · Subtotal: ${money.format(cart.total_price / 100)}`;
      const next = tiers.find(t => quantity < t.n);
      const current = [...tiers].reverse().find(t => quantity >= t.n);
      dialog.querySelector('.purebau-popup__message').textContent = next
        ? `${current ? `${current.pct}% off unlocked. ` : ''}Add ${next.n - quantity} more ${next.n - quantity === 1 ? 'item' : 'items'} to reach ${next.pct}% off.`
        : '10% off tier unlocked!';
      const points = [{ n: 2, x: 0 }, { n: 4, x: 33.333 }, { n: 6, x: 66.667 }, { n: 10, x: 100 }];
      const upper = points.findIndex(point => quantity < point.n);
      const progress = upper < 0 ? 100 : upper === 0 ? 0 :
        points[upper - 1].x + (quantity - points[upper - 1].n) *
        (points[upper].x - points[upper - 1].x) / (points[upper].n - points[upper - 1].n);
      dialog.querySelector('.purebau-popup__fill').style.width = `${progress}%`;
      dialog.querySelectorAll('[data-tier]').forEach(node => node.classList.toggle('is-reached', quantity >= Number(node.dataset.tier)));
      const section = dialog.querySelector('.purebau-popup__recommendations');
      const grid = dialog.querySelector('.purebau-popup__grid');
      grid.replaceChildren();
      section.hidden = true;
      if (!dialog.open) dialog.showModal();
      if (window.matchMedia('(max-width: 749px)').matches) return;
      if (!added?.product_id) return;
      let products = [];
      try {
        const recResponse = await fetch(root + `recommendations/products.json?product_id=${encodeURIComponent(added.product_id)}&limit=10&intent=related`, { credentials: 'same-origin', signal: AbortSignal.timeout(5000) });
        if (recResponse.ok) products = (await recResponse.json()).products || [];
      } catch (error) { /* Use store products when recommendations are unavailable. */ }
      if (request !== serial || !dialog.open || window.matchMedia('(max-width: 749px)').matches) return;
      const fallback = JSON.parse(document.getElementById('purebau-popup-fallback-products')?.textContent || '[]');
      const seen = new Set();
      products = [...products, ...fallback].filter(product => {
        const id = String(product.id);
        if (seen.has(id)) return false;
        seen.add(id); return Boolean(product.featured_image);
      });
      const cartIds = new Set(cart.items.map(item => String(item.product_id)));
      for (const product of products.filter(p => p.available && !cartIds.has(String(p.id))).slice(0, 8)) {
        const card = document.createElement('a');
        card.className = 'purebau-popup__product';
        card.href = product.url || root + 'products/' + encodeURIComponent(product.handle);
        if (product.featured_image) {
          const picture = document.createElement('img');
          picture.src = product.featured_image;
          picture.alt = '';
          picture.loading = 'lazy';
          card.append(picture);
        }
        const name = document.createElement('span');
        name.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'purebau-popup__price';
        price.textContent = money.format(Number(product.price) / 100);
        card.append(name, price);
        grid.append(card);
      }
      section.hidden = !grid.childElementCount;
    } catch (error) {
      console.warn('[purebau-cart-popup] Unable to show cart confirmation:', error);
    }
  });
}
